<template functional>
  <div>
    <a
      v-if="props.rowValue > 0"
      :key="index"
      href="#"
      @click="$options.show(props)"
      :class="[$options.className[props.row['Color' + props.mes]].Class]"
    >
      {{ props.rowValue }}
    </a>
  </div>
</template>

<!-- :class="[
  $options.monthName[props.row.Rojo].Name == props.column
    ? 'Rojo'
    : 'Azul'
]" -->
<script>
import { formatMonto } from "@/utils";
export default {
  formatMonto,
  name: "HyperlinkForModuleVacations",
  className: {
    0: { Class: "Rojo" },
    1: { Class: "Rojo" },
    2: { Class: "Amarillo" },
    3: { Class: "Verde" },
    4: { Class: "Azul" },
    5: { Class: "Naranja" }
  },
  show(ops) {
    ops;
    // console.log("sss", ops.row["Rojo" + ops.mes]);
    // ops.row.OpenDetailDataCliente(ops.row);
    ops.row.OpenDetailVacaciones(ops.row, ops.column, ops.row.year);
  }
};
</script>
<!-- class="Azul" -->
<!-- :class="[props.row.Rojo ? 'Rojo' : 'Azul']" -->

<style scoped>
.Rojo {
  width: 2rem;
  height: 2rem;
  color: #c71d10;
  background-color: rgba(221, 4, 4, 0.301);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin: auto;
  padding: 3%;
}

.Amarillo {
  width: 2rem;
  height: 2rem;
  color: black;
  background-color: rgba(231, 235, 5, 0.377);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin: auto;
  padding: 3%;
}

.Verde {
  width: 2rem;
  height: 2rem;
  color: rgb(0, 128, 0);
  background-color: rgba(2, 255, 107, 0.459);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin: auto;
  padding: 3%;
}
.Azul {
  width: 2rem;
  height: 2rem;
  color: blue;
  background-color: rgba(25, 133, 187, 0.281);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin: auto;
  padding: 3%;
}

.Naranja {
  width: 2rem;
  height: 2rem;
  color: rgb(231, 15, 15);
  background-color: rgba(167, 124, 32, 0.473);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin: auto;
  padding: 3%;
}
</style>
